function customCollectionSection(container) {
  var tabs_nav = container.querySelector(".index-tabs_nav");
  var sliderEl = container.querySelector(".index-tabs-content_block__slider");
  var flickityInstance;
  var slider_options;

  if (sliderEl) {
    slider_options = {
      prevNextButtons: false,
      wrapAround: true,
      dragThreshold: 15,
      watchCSS: true,
      cellAlign: "left",
      pauseAutoPlayOnHover: true,
      autoPlay: false,
      pageDots: false,
      groupCells: 5,
    };
    slider_options = {
      ...slider_options,
      ...JSON.parse(
        sliderEl.getAttribute("data-flickity-config")
      )
    }
    flickityInstance = new Flickity(sliderEl, slider_options);
    flickityInstance.element.classList.add("rendered");

    var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
    if (slider_custom_arrows) {
      var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
      slider_custom_btns.forEach(function (item, index) {
        item.addEventListener("click", function (e) {
          e.preventDefault();
          var isNext = item.classList.contains("button-next");
          if (isNext) {
            flickityInstance.next();
          } else {
            flickityInstance.previous();
          }
        });
      });
    }
  }
  if (tabs_nav) {
    tabs_nav
      .querySelectorAll(".index-tabs_nav--item")
      .forEach(function (item, index) {
        item.addEventListener("click", function (e) {
          e.preventDefault();

          var activeItem = tabs_nav.querySelector(
            ".index-tabs_nav--item.active"
          );
          var href_tab = this.getAttribute("data-href");
          var content_block = document.querySelector("#" + href_tab);

          if (activeItem) {
            activeItem.classList.remove("active");
            var active_content_block = document.querySelector(
              "#" + activeItem.getAttribute("data-href")
            );
            if (active_content_block) {
              active_content_block.classList.remove("active");

              var tab_content_slider = active_content_block.querySelector(
                ".index-tabs-content_block__slider"
              );
              if (tab_content_slider) {
                if (tab_content_slider.classList.contains("flickity-enabled")) {
                  flickityInstance.destroy();
                  flickityInstance.element.classList.remove("rendered");
                }
              }
            }
          }

          this.classList.add("active");
          if (content_block) {
            content_block.classList.add("active");

            var tab_content_slider = content_block.querySelector(
              ".index-tabs-content_block__slider"
            );
            if (tab_content_slider) {
              slider_options = JSON.parse(
                tab_content_slider.getAttribute("data-flickity-config")
              );
              flickityInstance = new Flickity(
                tab_content_slider,
                slider_options
              );
              flickityInstance.element.classList.add("rendered");

              flickityInstance.on("select", function (index) {
                var elementsCount =
                  container.querySelector(".flickity-slider").childElementCount;
              });

              var elementsCount =
                tab_content_slider.querySelector(
                  ".flickity-slider"
                ).childElementCount;

              if (slider_custom_arrows) {
                if (elementsCount > 1) {
                  if (slider_custom_arrows) {
                    slider_custom_arrows.classList.remove("hide");
                  }
                } else {
                  if (slider_custom_arrows) {
                    slider_custom_arrows.classList.add("hide");
                  }
                }
              }
            }
          }
        });
      });
  }
}

function CollectionListSection(container, slider_options) {
  var sectionCarousel = container.querySelector(".collection-list__slider");
  if (sectionCarousel) {
    var slider_options = {
      prevNextButtons: false,
      wrapAround: true,
      dragThreshold: 15,
      cellAlign: "left",
      pauseAutoPlayOnHover: true,
      autoPlay: false,
      pageDots: false,
      watchCSS: false,
    };

    var flickityInstance = new Flickity(sectionCarousel, slider_options);

    if (slider_options.watchCSS) {
      var resizeMobileFlag = false;
      function resizeMobileSliderHeight() {
        var windowWidth = window.innerWidth;
        if (windowWidth <= 1199) {
          if (!resizeMobileFlag) {
            if (flickityInstance.element.classList.contains("rendered")) {
              flickityInstance.element.classList.remove("rendered");
            }

            flickityInstance.resize();
            setTimeout(function () {
              flickityInstance.element.classList.add("rendered");
              resizeMobileFlag = true;
            }, 1000);
          }
        }
      }

      resizeMobileSliderHeight();
      window.addEventListener("resize", resizeMobileSliderHeight);
    } else {
      flickityInstance.element.classList.add("rendered");
    }

    var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
    if (slider_custom_arrows) {
      if (slider_options.watchCSS) {
        slider_custom_arrows.classList.add("desktopHide");
      }

      var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
      slider_custom_btns.forEach(function (item, index) {
        item.addEventListener("click", function (e) {
          e.preventDefault();

          if (flickityInstance) {
            var isNext = item.classList.contains("button-next");
            if (isNext) {
              flickityInstance.next();
            } else {
              flickityInstance.previous();
            }
          }
        });
      });
    }
  }
}

// init sliders in the design mode
if(Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    document.querySelectorAll('[data-section-type="custom-collection"]').forEach(slider => {
      customCollectionSection(slider)
    })
  });
  
  document.addEventListener('shopify:section:load', function (event) {
    document.querySelectorAll('[data-section-type="custom-collection-list"]').forEach(slider => {
      CollectionListSection(slider);
    })
  });
}
